/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nucleotide sequence`)
};

const es_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secuencia de nucleótidos`)
};

const de_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nukleotidsequenz`)
};

const nl_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nucleotidesequentie`)
};

const fr_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séquence nucléotidique`)
};

const it_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequenza nucleotidica`)
};

const pt_br2_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência de nucleotídeos`)
};

const pt_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sequência de nucleótidos`)
};

const ja_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヌクレオチド配列`)
};

const zh_dnamw_input_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核苷酸序列`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_input_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_input_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_input_label", locale)
	if (locale === "en") return en_dnamw_input_label(inputs)
	if (locale === "es") return es_dnamw_input_label(inputs)
	if (locale === "de") return de_dnamw_input_label(inputs)
	if (locale === "nl") return nl_dnamw_input_label(inputs)
	if (locale === "fr") return fr_dnamw_input_label(inputs)
	if (locale === "it") return it_dnamw_input_label(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_input_label(inputs)
	if (locale === "pt") return pt_dnamw_input_label(inputs)
	if (locale === "ja") return ja_dnamw_input_label(inputs)
	return zh_dnamw_input_label(inputs)
};